import { CircularProgress, Typography } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { OTPConfirmRequest, UserVerifyRequest } from "../../models/RequestModel";
import { VerificationResponse } from "../../models/ResponseModel";
import { UserInfoModel } from "../../models/UserInfoModel";
import { ApiConfig, ServiceApi } from "../../service/ServiceApi";
import { RootState } from "../../store";
import { actions as OTPAction } from "../../store/redux/OTPConfirmRedux";
import { actions as UserAction } from "../../store/redux/UserInfoRedux";
import { actions as VerificationAction } from "../../store/redux/UserVerificationRedux";
import { NavTo } from "../../utils/AppManager";
import { Path } from "../../utils/Constant";
import { fontUnit, heightUnit, padGinUnit, widthUnit } from "../../utils/DeviceManager";
const iOS = require('is-ios');

const MAXIMUM_OTP_FAILED = 3;
const DEFAULT_BLOCKING_TIME = 60;

export function OTPScreen() {
    const dispatch = useDispatch();
    const [userInfo, accessToken, unblockTime] = useSelector((state: RootState) => [
        state.userInfoReducer.userInfo,
        state.userVerificationReducer.accessToken,
        state.userVerificationReducer.accessToken.unblockTime,
    ]);

    const [otpValue, setOtpValue] = useState({ otp: '' })
    const [message, setMessage] = useState("")
    const [isRequesting, setIsRequesting] = useState(false)
    const [requestTime, setRequestTime] = useState(0)
    const [failTime, setFailTime] = useState(1)
    const [disableRequestOtp, setDisableRequestOtp] = useState(true)
    const [intervalId, setIntervalId] = useState<ReturnType<typeof setInterval> | null>(null);
    const [timer, setTimer] = useState(0);

    const screenWidth: number = window.innerWidth;;
    const OTP_INVALID = `รหัส OTP ไม่ถูกต้อง ลองใหม่ได้อีก ${MAXIMUM_OTP_FAILED - failTime} ครั้ง`
    const OTP_INVALID_OVER_MAX_LIMIT = 'ท่านได้ใส่รหัส OTP ผิดเกิน 3 ครั้ง\nกรุณาลองใหม่ในอีก 30 นาที';


    useEffect(() => {
        document.title = "สมัครใช้งาน\u200E\u200E\u200E\u200E\u200E\u200E"
    }, [])

    useEffect(() => {
        if (accessToken) {
            const newInfo: UserInfoModel = { ...userInfo, accessToken: accessToken.accessToken }
            UserAction.setUserInfo(dispatch, newInfo).then(() => {
                setOtpValue({ otp: '' })
            })
        }
    }, [accessToken])

    useEffect(() => {
        if (isValidOTP()) {
            onConfirm()
        }
    }, [otpValue])

    useEffect(() => {
        delayOTP()
    }, [])

    const delayOTP = () => {
        // const currentTime = new Date();
        // const toTime = new Date(unblockTime);
        // const diff = toTime.getTime() - currentTime.getTime();

        // let time = diff
        // if(diff<0){
        //     time = 60000
        // }
        // setTimeout(()=>{
        //     setDisableRequestOtp(false)
        // }, time)
        setDisableRequestOtp(true);
        setTimer(DEFAULT_BLOCKING_TIME);

        const intervalRef = setInterval(() => {
            setTimer((prevTime) => {
                const remaining = prevTime - 1;
                if (remaining === 0) {
                    setDisableRequestOtp(false);
                    setIntervalId(null);
                }
                return remaining;
            });
        }, 1000);
        // store interval ref
        setIntervalId(intervalRef);
    }

    useEffect(() => {
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [intervalId])

    const isValidOTP = () => {
        return otpValue.otp.length === 6;
    }

    const onConfirm = () => {
        if (isValidOTP()) {
            const request: OTPConfirmRequest = { accessToken: userInfo.accessToken, otp: otpValue.otp }
            setIsRequesting(true)
            axios.post(ServiceApi.OTP_CONFIRM, request, ApiConfig)
                .then((res) => {
                    const response: VerificationResponse = res.data
                    OTPAction.setOTPConfirm(dispatch, response.accessToken == userInfo.accessToken).then(() => {
                        console.log("Verifying OTP")
                        setIsRequesting(false)
                    })
                    return res;
                }).then(data => {
                    setIsRequesting(false)
                    if (data.data.accessToken === userInfo.accessToken) {
                        NavTo(Path.account)
                    } else {
                        setMessage("ขออภัย OTP หมดอายุ กรุณาลองใหม่ในอีกสักครู่")
                    }
                })
                .catch(error => {
                    setOtpValue({ otp: '' })
                    setIsRequesting(false)
                    const errorStr = JSON.stringify(error)
                    //httpStatusCode = 400, 409, ...
                    const httpStatusCode = error.response.status
                    //errorCode = BU005, BU006, .. 
                    const errorDataCode = error.response.data.code
                    console.log("errorStr: " + errorStr, ", httpStatusCode: " + httpStatusCode + ", errorCode: " + errorDataCode)
                   
                    if (httpStatusCode == 400 && errorDataCode == "BU005") {
                        //input incorrect OTP for the third time
                        //todo: navigate back to phone number page. (BU005).
                        NavTo(Path.mobile)
                    }
                    else if (httpStatusCode == 409 && errorDataCode == "BU008") {
                        //input incorrect OTP for the fourth time
                        //todo: display error message (BU008)
                        setMessage(OTP_INVALID_OVER_MAX_LIMIT)
                    }
                    else {
                        if (failTime > MAXIMUM_OTP_FAILED) {
                            setMessage(OTP_INVALID_OVER_MAX_LIMIT)
                        } else {
                            setFailTime(failTime + 1)
                            setMessage(OTP_INVALID)
                        }
                    }
                })
        }
    }

    const requestOtp = () => {
        if (disableRequestOtp) return;

        setIsRequesting(true)
        const request: UserVerifyRequest = {
            recipientCID: userInfo.nationalId,
            recipientPhoneNumber: userInfo.mobile,
            lineUserId: userInfo.lineUserId
        }
        VerificationAction.postVerification(dispatch, request)
            .then(() => {
                setMessage("")
                setIsRequesting(false)
                setRequestTime(requestTime + 1)
                console.log("OTP was requested successfully")
                delayOTP()
            })
            .catch(() => {
                setIsRequesting(false)
                console.log("Error while request OTP")
            })
    }

    const markText = (str: String) => {
        return "••• ••• " + str.substr(str.length - 4, str.length)
    }

    const onLoading = () => {
        return (
            <Typography
                align={"center"}
                style={{
                    position: "relative",
                    width: "100%",
                    alignContent: "center",
                    paddingTop: padGinUnit(200),
                }}>
                <CircularProgress color='primary' style={{ alignSelf: "center" }} />
            </Typography>
        )
    }

    const OTPWidget = () => {
        return (
            <div style={{ overflow: "none" }}>
                <DynamicTitle title={"ยืนยันตัวตน"} size={fontUnit(24)} isFull={true} align={"left"} />
                <Typography align={"left"} style={{ fontSize: fontUnit(16), color: AcnColorTheme.black, fontFamily: "Prompt-Regular", marginTop: padGinUnit(8) }}>
                    เราได้ส่งรหัสยืนยันตัวตน (OTP) ไปยังหมายเลขโทรศัพท์มือถือ {markText(userInfo.mobile)} เรียบร้อยแล้ว กรุณากรอกรหัสที่ได้เพื่อยืนยันตัวตน
                </Typography>
                <div style={{
                    maxWidth: window.innerWidth,
                    color: AcnColorTheme.black,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: padGinUnit(40),
                    marginBottom: padGinUnit(16)
                }}
                >
                    <OtpInput
                        value={otpValue.otp}
                        onChange={(event: any) => {
                            setMessage("")
                            setOtpValue({ otp: event })
                        }}
                        numInputs={6}
                        isDisabled={isRequesting}
                        inputStyle={{
                            fontSize: fontUnit(32),
                            width: iOS ? widthUnit(screenWidth / 20) : widthUnit(screenWidth / 9),
                            height: iOS ? heightUnit(35) : heightUnit(screenWidth / 10),
                            margin: "4px",
                            borderTop: "0px",
                            borderLeft: "0px",
                            borderRight: "0px",
                            borderBottom: "2px solid",
                            borderColor: AcnColorTheme.black,
                            outline: "none",
                            borderRadius: 0,
                            background: "transparent",
                            color: AcnColorTheme.black,
                            fontStyle: "medium"
                        }}
                        containerStyle={{
                            padding: "16px"
                        }}
                        isInputNum={true}
                        shouldAutoFocus={false}
                        errorStyle={{
                            borderColor: AcnColorTheme.secondaryRed,
                        }}
                        hasErrored={message !== ""}
                    />
                </div>
                {message && (
                    <Typography
                        align="left"
                        style={{
                            color: AcnColorTheme.secondaryRed,
                            fontSize: fontUnit(14),
                            fontFamily: "Prompt-Regular",
                            paddingBottom: padGinUnit(16)
                        }}
                    >
                        {message}
                    </Typography>
                )}

                <Typography align="left" style={{ fontSize: fontUnit(16), fontFamily: "Prompt-Regular", color: AcnColorTheme.black }}>
                    {
                        (userInfo.accessToken) ? (
                            `รหัสอ้างอิง: ${userInfo.accessToken.substr(0, 5)}`
                        ) : "กรุณาขอ OTP ใหม่อีกครั้ง"
                    }
                </Typography>

                {
                    requestTime < 2 ? (
                        <Typography align="left" style={{ marginTop: padGinUnit(4), 
                        fontSize: fontUnit(16), fontFamily: "Prompt-Regular", color: AcnColorTheme.black }}>
                            ยังไม่ได้รับรหัส&nbsp;
                            <span
                                aria-disabled={disableRequestOtp}
                                onClick={requestOtp}
                                style={{
                                    fontFamily: 'Prompt-Regular',
                                    color: disableRequestOtp ? AcnColorTheme.primaryPurple : AcnColorTheme.lightBlue,
                                    cursor: disableRequestOtp ? "default" : "pointer",
                                }}>
                                ส่งรหัสใหม่อีกครั้ง{disableRequestOtp ? `(${timer})` : ''}
                            </span>
                        </Typography>
                    ) : <div />
                }
                <div style={{ height: !iOS ? '250px' : '' }} />
            </div>
        )
    }

    return (
        <TemplateComponent content={isRequesting ? onLoading() : OTPWidget()}
            isCanNext={isValidOTP()}
            nextText={"ยืนยัน"} />
    );
}